import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getUserSelector } from '../../../redux/reducers/reducerSlices/UserReducer';
import { getReleaseBannerSelector } from '../../../redux/reducers/reducerSlices/ReleaseBannerReducer';
import { sagaActions } from '../../../sagas/sagaActions';
import Login from '../Login/Container/MainLogin/Login';
import './MainLandingPage.css';
import { AppConstant } from '../../Assests/AppConstant';
import { showLoader } from '../../Assests/Utility';
import ReleaseBanner from '../ReleaseBanner/ReleaseBanner';

// This component render login screen either for IMS or SchedulePro(IMS/SS) based on branding API response
const MainLandingPage = (props) => {

    const dispatch = useDispatch();
    const user = useSelector(getUserSelector);
    const { branding, brandingLoader, brandingSuccess, brandingError } = user;
    const backgroundImage = AppConstant.commonStrings.bkgImgLink;

    // Read the release banner state to determine if a force-update is active.
    // When forceUpdate=true the login form must be completely blocked — the user
    // must click "Update Now" in the ReleaseBanner before they can log in.
    const { isVisible, forceUpdate } = useSelector(getReleaseBannerSelector);
    const isForceUpdate = isVisible && forceUpdate === true;

    // useEffect to trigger branding API and fetch the public release banner
    // (no auth required — uses the public Lambda endpoint)
    useEffect(() => {
        dispatch({ type: sagaActions.CLEAR_BRANING })
        // set branding loader to true
        dispatch({ type: sagaActions.INITIATE_BRANDING_LOADER, payload: true })
        // split URL
        const subdomain = window.location.hostname.split(".")[0];
        dispatch({
            type: sagaActions.INITIATE_BRANDING, payload: {
                //  subdomain: subdomain,
                subdomain: process.env.REACT_APP_ENV === 'development' ? 'scheduleproqa' : subdomain
            }
        });
        // Fetch the release banner via the public (unauthenticated) Lambda endpoint.
        // The ReleaseBanner component self-guards (returns null when no banner is active),
        // so this has zero impact on the login UI when no banner is configured.
        dispatch({ type: sagaActions.FETCH_RELEASE_BANNER_PUBLIC });
    }, [])

    // useEffect after getting branding data
    useEffect(() => {
        // if brandingSuccess is true 
        if (brandingSuccess) {
            // if branding is not empty
            if (!_.isEmpty(branding)) {
                const { IsBranding, BackgroundImage } = branding;
                // if  IsBranding and BackgroundImage has data then render image
                if (IsBranding && BackgroundImage) {
                    const img = new Image();
                    img.src = BackgroundImage;
                    img.onload = () => {
                        setTimeout(() => {
                            dispatch({ type: sagaActions.INITIATE_BRANDING_LOADER, payload: false })
                        }, 1000)
                    };
                } else {
                    // else render default image
                    const img = new Image();
                    img.src = backgroundImage;
                    img.onload = () => {
                        setTimeout(() => {
                            dispatch({ type: sagaActions.INITIATE_BRANDING_LOADER, payload: false })
                        }, 1000)
                    };
                }
            } else {
                // else render default image
                const img = new Image();
                img.src = backgroundImage;
                img.onload = () => {
                    setTimeout(() => {
                        dispatch({ type: sagaActions.INITIATE_BRANDING_LOADER, payload: false })
                    }, 1000)
                };
            }

        }
        if (brandingError) {
            dispatch({ type: sagaActions.INITIATE_BRANDING_LOADER, payload: false })
        }
    }, [brandingSuccess, brandingError])

    return (
        <>
            {/* Release Banner — shown on the login page using the public (no-auth) Lambda.
                isPublic=true skips the "save your work" confirmation (no work to save at login).
                The component self-guards: returns null when no banner is active, so there
                is zero visual impact when no release banner is configured. */}
            <ReleaseBanner isPublic={true} />

            {/* Force-update gate — when the banner payload has forceUpdate=true the login
                form is rendered beneath a full-coverage overlay so the user cannot interact
                with any input or button until they click "Update Now" in the banner above.
                The wrapper uses position:relative so the absolute overlay is scoped to it.
                pointer-events:none on the login content + pointer-events:all on the overlay
                ensures keyboard and mouse events are fully blocked without hiding the UI. */}
            <div style={{ position: 'relative' }}>
                {/* Login content — visually dimmed and non-interactive during force-update */}
                <div
                    style={{
                        pointerEvents: isForceUpdate ? 'none' : 'auto',
                        opacity: isForceUpdate ? 0.4 : 1,
                        transition: 'opacity 0.2s ease',
                        userSelect: isForceUpdate ? 'none' : 'auto',
                    }}
                >
                    {/* if Subdomain is Schedulepro then Scheduleprologin otherwise IMS login */}
                    {brandingLoader ? showLoader(AppConstant.login.mainLandingLoaderText) : <Login />}
                </div>

                {/* Blocking overlay — only rendered during force-update.
                    Sits on top of the dimmed login form; intercepts all pointer events.
                    aria-hidden keeps it invisible to screen readers (the banner above
                    already conveys the "update required" message). */}
                {isForceUpdate && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 10,
                            pointerEvents: 'all',
                            cursor: 'not-allowed',
                        }}
                        aria-hidden="true"
                    />
                )}
            </div>
        </>
    );

}

export default MainLandingPage
